<template>
  <div class="home">
    <!-- :video="video" -->
    <!-- <start-page @getEnd="getEnd"></start-page> -->

    <div class="sub_banner banner_swiper">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(item, index) in banner_data"
          :key="index"
        >
          <video
            :src="item?.files && $imgurl + item?.files?.url"
            autoplay
            muted
            :poster="item?.exp1?.url && $imgurl + item?.exp1?.url"
            v-if="item?.files?.url"
          ></video>
          <img
            :src="item?.photo?.url && $imgurl + item?.photo?.url"
            :alt="item?.title"
            class=""
            v-else
          />
          <div class="txt">
            <div class="t1" v-html="item?.title"></div>
            <div class="t2" v-html="item?.entitle"></div>
            <a
              @click="tofina(item?.link)"
              class="more_btn cursor"
              v-if="item?.link && item?.subtitle"
              >{{ item.subtitle }}
            </a>
          </div>
        </div>
      </div>
      <div
        class="pagination2 swiper-pagination"
        v-if="banner_data.length > 1"
      ></div>
      <div class="swiper_btn prev_btn" v-if="banner_data.length > 1">
        <svg
          width="15"
          height="28"
          viewBox="0 0 15 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.6142 2.29808L3.0931 13.9337L14.5396 25.7417C15.0477 26.2603 15.0458 27.1028 14.5357 27.6236H14.5356C14.0255 28.1444 13.2 28.1462 12.6922 27.4945L0.481815 15.0311C0.317101 14.843 0.127798 14.6207 0.0964088 14.5007C-0.0964718 14.0114 7.72476e-05 13.4102 0.385927 12.916L12.7669 0.278492C13.2793 -0.111115 14.1085 -0.113143 14.6187 0.40764C15.1288 0.928423 15.1269 1.77478 14.6142 2.29808Z"
            fill="white"
          />
        </svg>
      </div>
      <div class="swiper_btn next_btn" v-if="banner_data.length > 1">
        <svg
          width="15"
          height="28"
          viewBox="0 0 15 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.385831 2.29808L11.9069 13.9337L0.460397 25.7417C-0.047654 26.2603 -0.045843 27.1028 0.464327 27.6236H0.46437C0.97454 28.1444 1.79997 28.1462 2.30775 27.4945L14.5182 15.0311C14.6829 14.843 14.8722 14.6207 14.9036 14.5007C15.0965 14.0114 14.9999 13.4102 14.6141 12.916L2.23306 0.278492C1.72072 -0.111115 0.891499 -0.113143 0.381285 0.40764C-0.12884 0.928423 -0.126855 1.77478 0.385831 2.29808Z"
            fill="white"
          />
        </svg>
      </div>
    </div>

    <!-- 新闻动态 -->
    <div class="box2">
      <div class="title">
        <span clas="z2">最新动态</span>
        <!-- <img src="../assets/img01/g_new.png" alt="" class="" /> -->
        <p class="mis">NEWS</p>
      </div>

      <div class="cont">
        <div class="right">
          <div
            class="lefr_z"
            v-if="index_cptd[0]"
            @click="toview2(index_cptd[0].url)"
          >
            <div class="image hover-deepen">
              <img :src="$imgurl + index_cptd[0]?.photo?.url" alt="" />
            </div>
            <div class="txt">
              <div class="txt_one es2" @click="toview2(index_cptd[0].url)">
                {{ index_cptd[0].title }}
              </div>
              <div class="txt_two">{{ index_cptd[0]?.timeline }}</div>
            </div>
          </div>

          <div
            class="lefr_z lefr_r"
            v-if="index_cptd[1]"
            @click="toview2(index_cptd[1].url)"
          >
            <div class="image hover-deepen">
              <img :src="$imgurl + index_cptd[1]?.photo?.url" alt="" />
            </div>
            <!-- <div class="txt_one" @click="torous">{{ index_hssj[0].title }}</div>
            <div class="txt_two" @click="torous">
              {{ index_hssj[0].yearnum }}年{{ index_hssj[0].subtitle }}
            </div>
            <div class="txt_a" @click="torous">MORE +</div> -->
            <div class="txt">
              <div class="txt_one es2" @click="toview2(index_cptd[1].url)">
                {{ index_cptd[1]?.title }}
              </div>
              <div class="txt_two">{{ index_cptd[1]?.timeline }}</div>
            </div>
          </div>
        </div>
        <div class="left">
          <div class="ul_l">
            <div
              class="sam_txt"
              v-for="(item, index) in [
                index_cptd[2],
                index_cptd[3],
                index_cptd[4],
                index_cptd[5]
              ]"
              :key="index"
              @click="toview2(item.url)"
            >
              <!-- @click="toview(item.id)" -->

              <div class="h_txt es2" v-html="item?.title"></div>
              <div class="h_txt2" v-html="item?.timeline"></div>
            </div>
          </div>

          <a href="/news/company">MORE +</a>
        </div>
      </div>

      <div class="title mar">
        <!-- 业务领域
        <img src="../assets/img01/BUSINESS.png" alt="" class="" /> -->
        <span clas="z2">业务领域</span>
        <p class="mis">BUSINESS</p>
      </div>
    </div>

    <div class="box3" v-if="index_trade[0]">
      <my-amit :ind="selected"></my-amit>
      <div class="text">
        <div class="txt" @click="toPath(index_trade[selected].id)">
          {{ index_trade[selected].title }}
        </div>
        <div
          v-html="index_trade[selected].content"
          @click="toPath(index_trade[selected].id)"
        ></div>

        <div class="imglogo">
          <img
            :src="
              index_trade[selected].exp1 &&
              $imgurl + index_trade[selected].exp1.url
            "
            alt=""
          />
        </div>
      </div>

      <div class="tabs">
        <div
          class="tablist cursor"
          :class="[{ hover: selected == index }]"
          v-for="(item, index) in index_trade2"
          :key="index"
          @click="getsele(index)"
          @mousemove="secuind = index"
          @mouseout="secuind = -1"
        >
          <!-- <img
            :src="
              selected == index || secuind == index
                ? item.exp3 && $imgurl + item.exp3.url
                : item.exp2 && $imgurl + item.exp2.url
            "
            alt=""
          /> -->
          <img
            v-show="selected == index || secuind == index"
            :src="item.exp3 && $imgurl + item.exp3.url"
            alt=""
          />
          <img
            v-show="!(selected == index || secuind == index)"
            :src="item.exp2 && $imgurl + item.exp2.url"
            alt=""
          />
          <div class="txt">{{ item.title }}</div>
        </div>

        <!-- <div class="txt_w">
          <div class="txt_a" @click="toPath(index_trade[selected].id)">
            MORE .
          </div>
        </div> -->
      </div>
    </div>

    <div class="box4">
      <div class="title">
        <span clas="z2">行业解决方案</span>
        <p class="mis">SOLUTION</p>
        <!-- 行业解决方案 -->
        <!-- <img src="../assets/img01/SOLUTION.png" alt="" class="" /> -->
      </div>

      <div class="cont" v-if="index_solution.length > 0">
        <div class="left">
          <div
            class="left_list cursor"
            :class="selected2 == index * 2 ? 'activeL' : ''"
            v-for="(item, index) in index_solution2.filter(
              (items, indexs) => indexs % 2 == 0
            )"
            :key="item.id"
            @click="changeBox4Li(index, 'l', item.id)"
            @mouseover="changelist(index, 'l', item.id)"
          >
            <!-- <img
              :src="
                cindex == item.id
                  ? item.exp2 && $imgurl + item.exp2.url
                  : item.photo && $imgurl + item.photo.url
              "
              alt=""
            /> -->
            <img
              v-show="cindex == item.id"
              :src="item.exp2 && $imgurl + item.exp2.url"
              alt=""
            />
            <img
              v-show="cindex !== item.id"
              :src="item.photo && $imgurl + item.photo.url"
              alt=""
            />

            <div class="bar">{{ item.title }}</div>
          </div>
        </div>

        <div
          class="middle"
          :style="{
            background: `url(${
              $imgurl + index_solution[selected2].exp1.url
            }) 0 0/cover no-repeat`
          }"
        >
          <div class="txt" @click="tolinktxt(index_solution[selected2].id)">
            {{ index_solution[selected2].title }}
          </div>
          <div
            class="txt_list"
            v-for="(item, indxe) in index_solution[selected2].second"
            :key="indxe"
            @click="tolink(index_solution[selected2].id, item.id)"
          >
            <div v-html="item.title"></div>
          </div>
        </div>

        <div class="right">
          <div
            :class="selected2 == index * 2 + 1 ? 'activeR' : ''"
            class="right_list cursor"
            v-for="(item, index) in index_solution2.filter(
              (items, indexs) => indexs % 2 == 1
            )"
            :key="item.id"
            @click="changeBox4Li(index, 'r', item.id)"
            @mouseover="changelist(index, 'r', item.id)"
          >
            <!-- <img
              :src="
                cindex == item.id
                  ? item.exp2 && $imgurl + item.exp2.url
                  : item.photo && $imgurl + item.photo.url
              "
              alt=""
            /> -->

            <img
              v-show="cindex == item.id"
              :src="item.exp2 && $imgurl + item.exp2.url"
              alt=""
            />
            <img
              v-show="cindex !== item.id"
              :src="item.photo && $imgurl + item.photo.url"
              alt=""
            />

            <div class="bar">{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="box5">
      <div>
        <div class="title">成为全球领先的金融科技公司</div>
        <router-link tag="div" to="/about" class="txt_a"> 了解更多</router-link>
      </div>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import Swiper from "swiper";
import myAmit from "@/components/amit";
import startPage from "@/components/startPage";
export default {
  components: {
    myAmit,
    startPage
  },
  data() {
    return {
      //头部三个
      index_news: [],
      //正在发生左边
      index_cptd: [],
      //活动
      index_hd: [],
      //恒生世界
      index_hssj: [],
      //业务领域
      index_trade: [],
      index_trade2: [],
      //行业解决方案
      index_solution: [],
      index_solution2: [],
      secuind: 0,
      curindex: -1,
      curin: -1,
      curins: -1,
      info: "",
      icon_1: [
        require("@/assets/img01/b1-s1.png"),
        require("@/assets/img01/b1-s2.png"),
        require("@/assets/img01/b1-s3.png")
      ],
      selected: 0,
      //行业解决方案
      list: [
        {
          title: "证券",
          icon: require("@/assets/img01/b4-1.png"),
          c_title: "证券",
          c_bg: require("@/assets/img01/b4-bg1.png"),
          c_list: [
            { title: "公募基金整体解决方案" },
            { title: "资管与投资解决方案" },
            { title: "财富管理解决方案" },
            { title: "机构服务解决方案" },
            { title: "风险管理与合规解决方案" },
            { title: "业务中台解决方案" },
            { title: "技术中台解决方案" },
            { title: "数据中台解决方案" },
            { title: "云基础解决方案" }
          ]
        },
        {
          title: "银行",
          icon: require("@/assets/img01/b4-2.png"),
          c_title: "银行",
          // c_bg:require(''),
          c_list: [{ title: "保险11111" }]
        },
        {
          title: "期货",
          icon: require("@/assets/img01/b4-3.png"),
          c_title: "期货",
          // c_bg:require(''),
          c_list: [{ title: "保险11111" }]
        },
        {
          title: "产业",
          icon: require("@/assets/img01/b4-4.png"),
          c_title: "产业",
          // c_bg:require(''),
          c_list: [{ title: "保险11111" }]
        },
        {
          title: "基金",
          icon: require("@/assets/img01/b4-5.png"),
          c_title: "基金",
          // c_bg: require("@/assets/img01/b4-bg.png"),
          c_list: [{ title: "保险11111" }]
        },
        {
          title: "私募",
          icon: require("@/assets/img01/b4-6.png"),
          c_title: "私募",
          // c_bg: require("@/assets/img01/b4-bg.png"),
          c_list: [{ title: "保险11111" }]
        },
        {
          title: "保险",
          icon: require("@/assets/img01/b4-7.png"),
          c_title: "保险",
          // c_bg: require("@/assets/img01/b4-bg.png"),
          c_list: [{ title: "保险11111" }]
        },
        {
          title: "金控集团",
          icon: require("@/assets/img01/b4-8.png"),
          c_title: "金控集团",
          // c_bg: require("@/assets/img01/b4-bg.png"),
          c_list: [{ title: "保险11111" }]
        },
        {
          title: "信托&AMC",
          icon: require("@/assets/img01/b4-9.png"),
          c_title: "信托&AMC",
          // c_bg: require("@/assets/img01/b4-bg.png"),
          c_list: [{ title: "保险11111" }]
        },
        {
          title: "基础设施",
          icon: require("@/assets/img01/b4-10.png"),
          c_title: "基础设施",
          // c_bg: require("@/assets/img01/b4-bg.png"),
          c_list: [{ title: "保险11111" }]
        }
      ],
      selected2: 0,
      // block1动画开始
      aniStar: false,
      // 网站开场视频
      video: "",
      cindex: 0,
      timer: "",
      banner_swiper: null,
      banner_data: [
        {
          title: "",
          entitle: "",
          files: "",
          link: "",
          photo: {
            id: "",
            alt: "",
            origin_name: "",
            text: "",
            title: "",
            url: ""
          }
        }
      ],
      logo_active: require("@/assets/img01/logo-active.png")
    };
  },
  beforeCreate() {
    // document.querySelector('body').setAttribute('style', 'filter:grayscale(100%)')
  },
  mounted() {
    //获取到配置的头部颜色，听过store监听动态改变
    this.$store.commit("until/SET_COLOR", "#fff");
    // this.getEnd();
    this.getdata();
    //业务领域自动播放调用
    this.getswipe();
    this.initSwiper();
    setTimeout(() => {
      console.log(this.$store.state.until.logo_active);
      if (this.$store.state.until.logo_active) {
        document.getElementById("logo").src = this.logo_active;
        document.querySelector(
          ".header-out .header-inner .find-out .icon"
        ).style.filter = "brightness(0) invert(1)";
        document.querySelector(".header-out .header-inner .lang").style.border =
          "1px solid #fff";
        document.querySelector(".header-out .header-inner .lang").style.color =
          "#fff";
      } else {
        // logoFlag = true
      }
    }, 200);
  },
  methods: {
    checkCookieAndDoTask() {
      if (Cookies.get("myCookieName")) {
        // 如果cookie存在，执行相应操作

        return (this.aniStar = !this.aniStar);
      } else {
        // 如果cookie不存在，执行另一项任务
        // this.startShow=!this.startShow

        // if (this.startShow) {
        this.$nextTick(() => {
          this.getEnd();
        });
        // }
      }
    },
    getEnd() {
      this.aniStar = false;
      if (!window.sessionStorage.getItem("start")) return;
      let timer = setTimeout(() => {
        this.aniStar = true;
        clearTimeout(timer);
      }, 0);
    },

    //数据请求
    getdata() {
      this.$fetch({
        url: "index.php/welcome/index",
        // url: "https://www.hundsun.com/v1api/index.php/welcome/index",

        type: "get"
      }).then((res) => {
        this.banner_data = res.data?.video;

        // this.index_news = res.data.index_news;
        this.index_cptd = res.data.index_cptd;
        // console.log(this.index_cptd);
        // console.log(this.index_news);
        // this.index_hd = res.data.index_hd;
        this.index_hssj = res.data.index_hssj;
        this.index_trade = res.data.index_trade;
        this.index_solution = res.data.index_solution;
        this.createArray();
        this.createArray2();
        // console.log(this.index_trade2);
        // this.video = this.$imgurl + res.data.video.files.url;
        this.checkCookieAndDoTask();

        setTimeout(() => {
          this.getswipe();
          this.initSwiper();
        }, 1000);
      });
    },
    initSwiper() {
      this.banner_swiper = new Swiper(".banner_swiper", {
        autoplay: 6000,
        slidesPerView: 1,
        // loop:true,
        effect: "fade",
        fadeEffect: {
          crossFade: false
        },
        speed: 500,
        pagination: ".banner_swiper .pagination2",
        paginationClickable: true,
        prevButton: ".banner_swiper .prev_btn",
        nextButton: ".banner_swiper .next_btn",
        onSlideChangeStart: (swiper) => {
          this.slideChange(swiper);
        }
      });
    },
    // banner切换 监听是否有视频
    slideChange(swiper) {
      const videoExists =
        document.querySelectorAll(".sub_banner .swiper-slide-active video")
          .length > 0;
      if (videoExists) {
        this.videoStop();
        swiper.stopAutoplay();
        this.playVideo(swiper);
      } else {
        swiper.startAutoplay();
      }
    },
    // banner视频播放
    playVideo(swiper) {
      const currentVideo = document.querySelector(
        ".sub_banner .swiper-slide-active video"
      );
      if (currentVideo) {
        currentVideo.play().catch((err) => {
          console.warn("视频播放失败:", err);
        });
        this.videoPlaying(swiper);
      }
    },
    videoStop() {
      // 获取所有 slide 中的 video 元素
      const allVideos = document.querySelectorAll(
        ".sub_banner .swiper-slide video"
      );
      if (allVideos.length === 0) return; // 没有视频，直接返回
      // 暂停其他视频 重置进度条
      allVideos.forEach((video) => {
        if (video && !video.paused) {
          video.pause();
          video.currentTime = 0; // 重置进度条（可选）
        }
      });
    },
    //  视频监听
    videoPlaying(swiper) {
      // 视频播放完成
      const videoExists =
        document.querySelectorAll(".sub_banner .swiper-slide-active video")
          .length > 0;
      if (!videoExists) return;
      document
        .querySelector(".sub_banner .swiper-slide-active video")
        .addEventListener("ended", () => {
          setTimeout(() => {
            // swiper.slideNext();
            swiper.startAutoplay();
          }, 1000);
        });
    },
    createArray() {
      this.index_trade.forEach((item) => {
        console.log(item.title);
        if (item.title != "行业咨询") {
          this.index_trade2.push(item);
        }
      });
    },
    createArray() {
      this.index_trade.forEach((item) => {
        console.log(item.title);
        if (item.title != "行业咨询") {
          this.index_trade2.push(item);
        }
      });
    },
    createArray2() {
      this.index_solution.forEach((item) => {
        if (item.title != "行业解决方案") {
          this.index_solution2.push(item);
        }
      });
    },
    torou(id) {
      this.$router.push({ path: "/newsview", query: { id } });
    },
    torour() {
      this.$router.push({ path: "/news/product" });
    },
    torout() {
      this.$router.push({ path: "/news/bazaar" });
    },
    torous() {
      this.$router.push({ path: "/news/world" });
    },
    toPath(id) {
      this.$router.push({ path: "/business", query: { id } });
    },
    tolink(id, selfid) {
      this.$router.push({ path: "/industry", query: { id, selfid } });
    },
    tolinktxt(id) {
      //  console.log(index);
      this.$router.push({ path: "/industry", query: { id } });
    },
    changeBox4Li(index, type, key) {
      this.selected2 = type == "l" ? index * 2 : index * 2 + 1;
      this.cindex = key;
    },
    tolinka(url) {
      window.open(url);
    },
    tove(id) {
      this.$router.push({ path: "/newsview", query: { id: id } });
    },
    tovw(id) {
      // console.log(id);
      this.$router.push({ path: "/newsview", query: { id: id } });
    },
    //行业解决方案划入事件
    changelist(index, type, key) {
      this.selected2 = type == "l" ? index * 2 : index * 2 + 1;
      this.cindex = key;
    },
    //业务领域自动播放
    getswipe() {
      this.timer = setInterval(() => {
        this.selected++;
        if (this.selected > 5) {
          this.selected = 0;
        }
      }, 6000);
    },
    //业务领域点击
    getsele(index) {
      this.selected = index;
      //点击后清除计时器
      clearInterval(this.timer);
      this.timer = null;
    },
    //正在发生跳详情
    toview(id) {
      this.$router.push({ path: "/newsview", query: { id: id, flg: false } });
    },
    toview2(url) {
      window.open(url, "_blank");
      // this.$router.push({ path: "/newsview", query: { id: id, flg: true } });
    },
    tofina(sec) {
      //  this.$router.push({path:"/finance"})
      // const { href } = this.$router.resolve({
      //   name: "finance",
      //   query: {
      //     id: 1,
      //   },
      // });
      window.open(sec, "_blank");
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$store.commit("until/SET_COLOR", "#fff");
      vm.$store.commit("until/SET_LOGO_ACTIVE", true);
    });
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("until/SET_COLOR", "#333");
    this.$store.commit("until/SET_LOGO_ACTIVE", false);
    document.getElementById("logo").src = require("@/assets/images/logo.gif");
    document.querySelector(
      ".header-out .header-inner .find-out .icon"
    ).style.filter = "none";
    document.querySelector(".header-out .header-inner .lang").style.border =
      "1px solid #396aff";
    document.querySelector(".header-out .header-inner .lang").style.color =
      "#396aff";
    next();
  },
  // 跳转其他路由清除定时器：
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  }
};
</script>

<style>
.home .box3 .text > div p {
  margin-bottom: 12px;
  cursor: pointer;
  text-align: justify;
}
</style>
<style lang="scss" scoped>
$header: 72px;
.box1 {
  width: 100%;
  height: 750px;
  padding-top: $header;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: url("../assets/img01/b1-bg.png");
  background-size: cover;
  background-position: center center;
  overflow: hidden;
}
.box1 .box1-inner {
  width: 1092px;
  margin: 0 auto;
  position: relative;
  transition: top 2.5s ease;
}
.box1 .son_div {
  margin-right: 36px;
}
.box1 .son_div:nth-of-type(3n + 3) {
  margin-right: 0;
}
.box1 .link {
  display: flex;
  align-items: center;
  width: fit-content;
  cursor: pointer;
}
.box1 .link span {
  font-size: 12px;
  font-weight: 500;
}
.box1 .son_div:nth-child(1) .link span {
  color: #8851c6;
}
.box1 .son_div:nth-child(2) .link span {
  color: #396aff;
}
.box1 .son_div:nth-child(3) .link span {
  color: #fdb51f;
}
.box1 .link img {
  width: 16px;
  height: 16px;
  margin-right: 4px;
}
.box1 .txt {
  font-size: 18px;
  height: 48px;
  font-weight: bold;
  color: #333333;
  margin: 32px 0 16px 0;
  line-height: 24px;
  width: 328px;
  cursor: pointer;
}
.box1 .image {
  width: 340px;
  height: 346px;
  cursor: pointer;
  overflow: hidden;
}
// .box1 .image:hover img {
//   transform: scale(1.1);
//   transition: all 0.3s linear;
// }
.box1 .image img {
  width: 100%;
  height: 100%;
  transition: all 0.3s linear;
}

.box2 {
  width: 100%;
  height: auto;
  background: linear-gradient(161deg, #ffffff 0%, #ebeef0 100%);
}

.box2 .title {
  width: 160px;
  margin: 0 auto;
  padding: 138px 0 50px;
  font-size: 36px;
  font-weight: 400;
  color: #333333;
  line-height: 50px;
  letter-spacing: 4px;
  position: relative;
}

.box2 .title img {
  width: 304px;
  height: auto;
  position: absolute;
  left: 50%;
  bottom: 36px;
  z-index: 0;
  transform: translateX(-50%);
}

.box2 .cont {
  width: 1200px;
  padding: 0 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
  margin: 0 auto;
}
.box2 .cont a {
  width: 100%;
  display: block;
  text-align: right;
  margin-top: 0;
  color: #4a47ff;
  line-height: normal;
  font-size: 14px;
  margin: auto 0 0 0;
  line-height: 1;
}

.box2 .cont .left {
  width: 425px;
  height: auto;
  margin-right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid rgba(102, 102, 102, 0.1);
  // padding-bottom: 38px;
}
.box2 .cont .left .ul_l {
  width: 100%;
}

.box2 .cont .right {
  width: 757px;
  height: auto;
  display: flex;
  margin-right: 18px;
}

.box2 .sam_txt {
  width: 100%;
  padding: 6px 23px 6px;
  border-bottom: 1px solid rgba(102, 102, 102, 0.1);
}

// .box2 .sam_txt:last-child {
//   border-bottom: 0;
// }
.box2 .h_txt {
  font-size: 14px;
  font-weight: 600;

  color: #333333;
  cursor: pointer;
}
.box2 .sam_txt:hover .h_txt {
  color: #4a47ff;
}
.box2 .h_txt2 {
  font-size: 13px;
  font-weight: 400;
  color: #999;
  line-height: 1;
  margin: 16px 0 0;
  cursor: pointer;
}

.box2 .lefr_z {
  display: flex;
  width: 50%;

  flex-direction: column;
  margin-left: 0;
}

.box2 .lefr_r {
  padding-right: 0;
}

.box2 .lefr_z .image {
  width: 100%;
  // min-height: auto;
  height: 369px;
  cursor: pointer;
  overflow: hidden;
}

.box2 .lefr_z .image img {
  width: 100%;
  height: 100%;
  transition: all 0.3s linear;
}

.box2 .lefr_z .txt {
  // margin: 37px 0 16px 0;
  font-size: 24px;
  color: #333333;
  font-weight: 600;
  cursor: pointer;
  width: 100%;
  height: 82px;
  padding: 12px 27px 12px;
  background: #fff;
}
.box2 .lefr_z .txt_one {
  height: 44px;
  font-size: 15px;
  line-height: 1.3;
  color: #333333;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 2px;
  position: relative;
  z-index: 1;
}

.box2 .lefr_z .txt_two {
  width: 100%;
  // height: 12px;
  font-size: 13px;
  line-height: 1.3;
  font-weight: 400;
  color: #999;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  position: relative;
  z-index: 1;
}

.box2 .lefr_z .txt_a {
  font-size: 12px;
  color: #396aff;
  width: fit-content;
  cursor: pointer;
}

.box2 .right .lefr_z:nth-child(2) .txt_a {
  color: #fdb51f;
}

.box2 .mar {
  padding: 0;
  padding-top: 140px;
  position: relative;
}

.box2 .mar img {
  position: absolute;
  bottom: 10px;
  // left: calc(50% - 243.5px);
  left: 50%;
  transform: translateX(-50%);
  width: 487px;
}

.box3 {
  width: 100%;
  height: 685px;
  background-image: url(../assets/img01/index-bg.png);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  position: relative;
  background-size: cover;
}
.box3 .imglogo img {
  position: absolute;
  top: -70px;
  left: 162px;
  max-height: 103px;
  max-width: 240px;
}
.box3 .text {
  width: 300px;
  color: #fff;
  position: absolute;
  top: 137px;
  right: 350px;
}
.box3 .text > div {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin-bottom: 25px;
  text-align: justify;
}
.box3 .text .txt {
  font-size: 32px;
  line-height: 42px;
  cursor: pointer;
}
.box3 .tabs .txt_w {
  display: flex;
  justify-content: flex-end;
  position: absolute;
  top: -86px;
  right: 80px;
}

.box3 .tabs .txt_a {
  font-size: 12px;
  color: #06d3da;
  text-align: right;
  width: fit-content;
  cursor: pointer;
}
.box3 .tabs {
  display: flex;
  justify-content: space-between;
  position: relative;
  z-index: 3;
}
.box3 .tablist {
  width: 200px;
  height: 140px;
  border: 1px solid #8c99f3;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  cursor: pointer;
  position: relative;
}
.box3 .tablist::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url("../assets/img01/b3-tabs.png");
  opacity: 0;
  transition: all 0.5s linear;
  z-index: -1;
}
.box3 .tablist:hover::after {
  opacity: 1;
}
.box3 .tablist:hover .txt {
  color: #4d3ddf;
  font-weight: 600;
}
.box3 .tablist.hover {
  background: url("../assets/img01/b3-tabs.png");
}
.box3 .tablist.hover .txt {
  color: #4d3ddf;
  font-weight: 600;
}
.box3 .tablist img {
  width: 24px;
  height: 24px;
}
.box3 .tablist .txt {
  margin-top: 12px;
  font-size: 14px;
}
.box4 {
  width: 100%;
  height: 1030px;
  background: rgb(240, 242, 246);
}
.box4 .title {
  width: 240px;
  height: 50px;
  font-size: 36px;
  margin: 0 auto 55px;
  font-weight: 400;
  color: #000000;
  padding: 138px 0 64px 0;
  position: relative;
}
.box4 .title img {
  width: 503px;
  height: 75px;
  position: absolute;
  bottom: 20px;
  left: calc(50% - 251.5px);
}
.box4 .cont {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.box4 .cont .left_list,
.box4 .cont .right_list {
  width: 250px;
  height: 135px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  transition: all 0.5s linear;
  background-color: hsla(0, 0%, 0%, 0);
}
.box4 .cont .left_list img,
.box4 .cont .right_list img {
  width: 66px;
  height: 66px;
  margin-bottom: 10px;
}

.box4 .cont .left_list:hover {
  // background: url(../assets/img01/b4-left.png);
  background-color: #fff;
  background-size: cover;
}
.box4 .cont .right_list:hover {
  // background: url(../assets/img01/b4-right.png);
  background-size: cover;
  background-color: #fff;
}
.box4 .cont .left_list:hover::after {
  content: "";
  position: absolute;
  width: 4px;
  height: 136px;
  background: linear-gradient(288deg, #64baff 0%, #3484ff 100%);
  left: 0;
}
.box4 .cont .right_list:hover::after {
  content: "";
  position: absolute;
  width: 4px;
  height: 136px;
  background: linear-gradient(288deg, #64baff 0%, #3484ff 100%);
  right: 0;
}
.box4 .cont .activeL {
  // background: url(../assets/img01/b4-left.png);
  background-color: #fff;

  background-size: cover;
  position: relative;
}
.box4 .cont .activeL::after {
  content: "";
  position: absolute;
  width: 4px;
  height: 136px;
  background: linear-gradient(288deg, #64baff 0%, #3484ff 100%);
  left: 0;
  top: 0;
}
.box4 .cont .activeR {
  // background: url(../assets/img01/b4-right.png);
  background-color: #fff;

  background-size: cover;
  position: relative;
}
.box4 .cont .activeR::after {
  content: "";
  position: absolute;
  width: 4px;
  height: 136px;
  background: linear-gradient(288deg, #64baff 0%, #3484ff 100%);
  right: 0;
  top: 0;
}

.box4 .cont .left_list .bar,
.box4 .cont .right_list .bar {
  font-size: 16px;
  font-weight: 400;
  color: #333333;
}

.box5 {
  width: 100%;
  height: 200px;
  background: #06d3da;
  display: flex;
  justify-content: center;
  align-items: center;
  background: url("../assets/img01/b5-bg.png");
}
.box5 > div {
  height: 85px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.box5 .title {
  font-size: 28px;
  color: #ffffff;
  margin: 0 auto;
  letter-spacing: 5px;
}
.box5 .txt_a:hover {
  background: #fff;
  color: #3890ff;
  transition: all 0.3s linear;
}
.box5 .txt_a {
  width: 102px;
  height: 32px;
  margin: 0 auto 0;
  text-align: center;
  line-height: 32px;
  border: 1px solid #fff;
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  transition: all 0.3s linear;
  cursor: pointer;
}
.box4 .middle {
  width: 699px;
  height: 675px;
  box-shadow: 10px 10px 24px 0px rgba(255, 255, 255, 0.6);
}
.box4 .middle .txt {
  font-size: 24px;
  color: #333333;
  margin: 40px 60px;
  font-weight: 600;
  cursor: pointer;
}
.box4 .middle .txt_list div {
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  margin-bottom: 20px;
  margin-left: 60px;
  cursor: pointer;
}
//  20260506 首页改版
// 新增字体 钉钉
.es {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.es2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* 限制行数 */
  -webkit-box-orient: vertical;
}
.es5 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5; /* 限制行数 */
  -webkit-box-orient: vertical;
}
@font-face {
  font-family: "DingTalk JinBuTi";
  src: url("../assets/fonts/DingTalk JinBuTi.ttf");
}
@font-face {
  font-family: "MISANS-SEMIBOLD";
  src: url("../assets/fonts/MISANS-SEMIBOLD.TTF");
}
.mis {
  font-family: "MISANS-SEMIBOLD";
  font-size: 100px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 80px;
  line-height: 1;
  z-index: 0;
  color: #bdc1cc;
  opacity: 0.09;
  font-weight: 450;
}

.z2 {
  position: relative;
  z-index: 2;
}

.sub_banner {
  width: 100%;
  overflow: hidden;
  // height: 100vh;
  height: 100vh;
  position: relative;
}

.sub_banner .swiper-wrapper,
.sub_banner .swiper-slide {
  position: relative;
  width: 100%;
  height: 100%;
}
.sub_banner .swiper-slide img,
.sub_banner .swiper-slide video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.sub_banner .swiper-slide .txt {
  width: 50%;
  position: absolute;
  top: 34%;
  left: 50%;
  transform: translate(-50%, 0%);
}
.sub_banner .swiper-slide .txt .t1 {
  font-family: "DingTalk JinBuTi";
  font-size: 72px;
  line-height: 82px;
  text-align: center;
  color: #fff;
}
.sub_banner .swiper-slide .txt .t2 {
  margin-bottom: 49px;
  margin-top: 18px;
  color: #fff;
  text-align: center;
  text-shadow: 0 5px 20px rgba(30, 136, 240, 0.25);
  font-size: 42px;
  line-height: 1.2;
  letter-spacing: 20%;
}
.sub_banner .swiper-slide .txt .more_btn {
  width: 120px;
  height: 40px;
  border: 0.5px solid #fff;
  border-radius: 2px;
  overflow: hidden;
  line-height: 1;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  border-radius: 4px;
  overflow: hidden;
  font-size: 14px;
}
.sub_banner .swiper-slide .txt .more_btn svg {
  margin-left: 4px;
  margin-top: 2px;
}
.sub_banner .swiper_btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  cursor: pointer;
}
.sub_banner .swiper_btn:hover {
  opacity: 0.8;
}
.sub_banner .swiper_btn.swiper-button-disabled {
  opacity: 0.5;
  pointer-events: none;
}
.sub_banner .prev_btn {
  left: 61px;
}
.sub_banner .next_btn {
  right: 61px;
}
.sub_banner .pagination2 {
  position: absolute;
  left: 50%;
  bottom: 40px;
  transform: translateX(-50%);
}
::v-deep.sub_banner .pagination2 span {
  width: 11px !important;
  height: 11px !important;
  border-radius: 50%;
  opacity: 0.5;
  background-color: #fff !important;
}
::v-deep.sub_banner .pagination2 span.swiper-pagination-bullet-active {
  opacity: 1;
}

@media (min-width: 1280px) {
  $header: 72px;
  .box1 {
    width: 100%;
    height: 750px;
    padding-top: $header;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background: url("../assets/img01/b1-bg.png");
    background-size: cover;
    background-position: center center;
    overflow: hidden;
  }
  .box1 .box1-inner {
    width: 1092px;
    margin: 0 auto;
    position: relative;
    transition: top 2.5s ease;
  }
  .box1 .son_div {
    margin-right: 36px;
  }
  .box1 .son_div:nth-of-type(3n + 3) {
    margin-right: 0;
  }
  .box1 .link {
    display: flex;
    align-items: center;
    width: fit-content;
    cursor: pointer;
  }
  .box1 .link span {
    font-size: 12px;
    font-weight: 500;
  }
  .box1 .son_div:nth-child(1) .link span {
    color: #8851c6;
  }
  .box1 .son_div:nth-child(2) .link span {
    color: #396aff;
  }
  .box1 .son_div:nth-child(3) .link span {
    color: #fdb51f;
  }
  .box1 .link img {
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }
  .box1 .txt {
    font-size: 18px;
    height: 48px;
    font-weight: bold;
    color: #333333;
    margin: 32px 0 16px 0;
    line-height: 24px;
    width: 328px;
    cursor: pointer;
  }
  .box1 .image {
    width: 340px;
    height: 346px;
    cursor: pointer;
    overflow: hidden;
  }

  .box1 .image img {
    width: 100%;
    height: 100%;
    transition: all 0.3s linear;
  }
  .box2 {
    width: 100%;
    height: auto;
    padding-bottom: 50px;
    background: linear-gradient(161deg, #ffffff 0%, #ebeef0 100%);
  }

  .box2 .title {
    width: 160px;
    margin: 0 auto;
    padding: 138px 0 50px;
    font-size: 36px;
    font-weight: 400;
    color: #333333;
    line-height: 50px;
    letter-spacing: 4px;
    position: relative;
  }

  .box2 .lefr_z .image img {
    width: 100%;
    height: 100%;
    transition: all 0.3s linear;
  }

  .box2 .mar {
    padding: 0;
    padding-top: 140px;
    position: relative;
  }
  // .box3 {
  //   width: 100%;
  //   height: 685px;
  //   background-image: url(../assets/img01/index-bg.png);
  //   display: flex;
  //   justify-content: center;
  //   align-items: flex-end;
  //   position: relative;
  //   background-size: cover;
  // }
  // .box3 .imglogo img {
  //   position: absolute;
  //   top: -70px;
  //   left: 145px;
  //   max-height: 80px;
  //   max-width: 250px;
  // }
  .box3 .text {
    width: 350px;
    //   color: #fff;
    //   position: absolute;
    //   top: 137px;
    //   right: 436px;
  }
  .box3 .text > div {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    margin-bottom: 25px;
    text-align: justify;
  }
  // .box3 .text .txt {
  //   font-size: 32px;
  //   line-height: 42px;
  // }
  // .box3 .text .txt_w{
  //   display: flex;
  //   justify-content: flex-end;
  // }

  // .box3 .text .txt_a {
  //   font-size: 12px;
  //   color: #06d3da;
  //   text-align: right;
  //   width: fit-content;
  //   cursor: pointer;

  // }
  // .box3 .tabs {
  //   display: flex;
  //   justify-content: space-between;
  //   position: relative;
  //   z-index: 3;
  // }
  // .box3 .tablist {
  //   width: 200px;
  //   height: 140px;
  //   border: 1px solid #8c99f3;
  //   display: flex;
  //   flex-direction: column;
  //   align-items: center;
  //   justify-content: center;
  //   color: #fff;
  //   cursor: pointer;
  //   position: relative;
  // }
  // .box3 .tablist::after {
  //   content: "";
  //   position: absolute;
  //   top: 0;
  //   left: 0;
  //   width: 100%;
  //   height: 100%;
  //   background: url("../assets/img01/b3-tabs.png");
  //   opacity: 0;
  //   transition: all 0.5s linear;
  //   z-index: -1;
  // }
  // .box3 .tablist:hover::after {
  //   opacity: 1;
  // }
  // .box3 .tablist:hover .txt {
  //   color: #4d3ddf;
  //   font-weight: 600;
  // }
  // .box3 .tablist.hover {
  //   background: url("../assets/img01/b3-tabs.png");
  // }
  // .box3 .tablist.hover .txt {
  //   color: #4d3ddf;
  //   font-weight: 600;
  // }
  // .box3 .tablist img {
  //   width: 24px;
  //   height: 24px;
  // }
  .box3 .tablist .txt {
    // margin-top: 12px;
    font-size: 14px;
  }
  .box4 {
    width: 100%;
    height: 1030px;
    background: rgb(240, 242, 246);
  }
  .box4 .title {
    width: 240px;
    height: 50px;
    font-size: 36px;
    margin: 0 auto 55px;
    font-weight: 400;
    color: #000000;
    padding: 138px 0 64px 0;
    position: relative;
  }
  .box4 .title img {
    width: 503px;
    height: 75px;
    position: absolute;
    bottom: 20px;
    left: calc(50% - 265.5px);
  }
  .box4 .cont {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
  }
  .box4 .cont .left_list,
  .box4 .cont .right_list {
    width: 250px;
    height: 135px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    transition: all 0.5s linear;
    background-color: hsla(0, 0%, 0%, 0);
  }
  .box4 .cont .left_list img,
  .box4 .cont .right_list img {
    width: 66px;
    height: 66px;
    margin-bottom: 10px;
  }

  .box4 .cont .left_list:hover {
    // background: url(../assets/img01/b4-left.png);
    background-size: cover;
    background-color: #fff;
  }
  .box4 .cont .right_list:hover {
    background-color: #fff;

    // background: url(../assets/img01/b4-right.png);
    background-size: cover;
  }
  .box4 .cont .left_list:hover::after {
    content: "";
    position: absolute;
    width: 4px;
    height: 136px;
    background: linear-gradient(288deg, #64baff 0%, #3484ff 100%);
    left: 0;
  }
  .box4 .cont .right_list:hover::after {
    content: "";
    position: absolute;
    width: 4px;
    height: 136px;
    background: linear-gradient(288deg, #64baff 0%, #3484ff 100%);
    right: 0;
  }
  .box4 .cont .activeL {
    // background: url(../assets/img01/b4-left.png);
    background-color: #fff;

    background-size: cover;
    position: relative;
  }
  .box4 .cont .activeL::after {
    content: "";
    position: absolute;
    width: 4px;
    height: 136px;
    background: linear-gradient(288deg, #64baff 0%, #3484ff 100%);
    left: 0;
    top: 0;
  }
  .box4 .cont .activeR {
    // background: url(../assets/img01/b4-right.png);
    background-color: #fff;

    background-size: cover;
    position: relative;
  }
  .box4 .cont .activeR::after {
    content: "";
    position: absolute;
    width: 4px;
    height: 136px;
    background: linear-gradient(288deg, #64baff 0%, #3484ff 100%);
    right: 0;
    top: 0;
  }

  .box4 .cont .left_list .bar,
  .box4 .cont .right_list .bar {
    font-size: 16px;
    font-weight: 400;
    color: #333333;
  }

  .box5 {
    width: 100%;
    height: 200px;
    background: #06d3da;
    display: flex;
    justify-content: center;
    align-items: center;
    background: url("../assets/img01/b5-bg.png");
  }
  .box5 > div {
    height: 85px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }
  .box5 .title {
    font-size: 28px;
    color: #ffffff;
    margin: 0 auto;
    letter-spacing: 5px;
  }
  .box5 .txt_a:hover {
    background: #fff;
    color: #3890ff;
    transition: all 0.3s linear;
  }
  .box5 .txt_a {
    width: 102px;
    height: 32px;
    margin: 0 auto 0;
    text-align: center;
    line-height: 32px;
    border: 1px solid #fff;
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
    transition: all 0.3s linear;
    cursor: pointer;
  }
  .box4 .middle {
    width: 699px;
    height: 675px;
    box-shadow: 10px 10px 24px 0px rgba(255, 255, 255, 0.6);
  }
  .box4 .middle .txt {
    font-size: 24px;
    color: #333333;
    margin: 40px 60px;
    font-weight: 600;
  }
  .box4 .middle .txt_list div {
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    margin-bottom: 20px;
    margin-left: 60px;
    cursor: pointer;
  }

  //
  .sub_banner .swiper-slide .txt .more_btn {
    font-size: 14px;
    width: 120px;
    height: 40px;
  }
  .sub_banner .swiper-slide .txt .more_btn svg {
    margin-left: 4px;
  }
}
@media (max-width: 1300px) and (min-width: 768px) {
  .box2 .cont {
    padding: 0 0%;
    margin: 0 auto;
  }
}

@media (max-width: 1367px) and (min-width: 1280px) {
  $header: calc(72px * 0.9);
  .box1 {
    width: 100%;
    height: calc(750px * 0.9);
    padding-top: $header;
    display: flex;
    // justify-content: center;
    align-items: center;
    background: url("../assets/img01/b1-bg.png");
    background-size: cover;
    background-position: center center;
    overflow: hidden;
  }
  .box1 .box1-inner {
    width: calc(1092px * 0.9);
    margin: 0 auto;
    position: relative;
    transition: top 2.5s ease;
  }
  .box1 .son_div {
    margin-right: calc(36px * 0.9);
  }
  .box1 .son_div:nth-of-type(3n + 3) {
    margin-right: 0;
  }
  .box1 .link {
    display: flex;
    align-items: center;
    width: fit-content;
    cursor: pointer;
  }
  .box1 .link span {
    font-size: 12px;
    font-weight: 500;
  }
  .box1 .son_div:nth-child(1) .link span {
    color: #8851c6;
  }
  .box1 .son_div:nth-child(2) .link span {
    color: #396aff;
  }
  .box1 .son_div:nth-child(3) .link span {
    color: #fdb51f;
  }
  .box1 .link img {
    width: calc(16px * 0.9);
    height: calc(16px * 0.9);
    margin-right: calc(4px * 0.9);
  }
  .box1 .txt {
    font-size: 18px;
    height: calc(48px * 0.9);
    font-weight: bold;
    color: #333333;
    margin: calc(32px * 0.9) 0 calc(16px * 0.9) 0;
    line-height: calc(24px * 0.9);
    width: calc(328px * 0.9);
    cursor: pointer;
  }
  .box1 .image {
    width: calc(340px * 0.9);
    height: calc(346px * 0.9);
    cursor: pointer;
    overflow: hidden;
  }
  // .box1 .image:hover img {
  //   transform: scale(1.1);
  //   transition: all 0.3s linear;
  // }
  .box1 .image img {
    width: 100%;
    height: 100%;
    transition: all 0.3s linear;
  }
  .box2 {
    width: 100%;
    height: calc(1073px * 0.9);
    background: linear-gradient(161deg, #ffffff 0%, #ebeef0 100%);
  }

  .box2 .title {
    width: 160px;
    margin: 0 auto;
    padding: calc(138px * 0.9) 0 calc(50px * 0.9);
    font-size: 36px;
    font-weight: 400;
    color: #333333;
    line-height: calc(50px * 0.9);
    letter-spacing: calc(4px * 0.9);
    position: relative;
  }

  .box2 .cont {
    display: flex;
    justify-content: center;
  }

  .box2 .mar {
    padding: 0;

    padding-top: calc(140px);
    position: relative;
  }
  .box3 .tablist .txt {
    font-size: 14px;
  }
  .box4 {
    width: 100%;
    height: calc(1030px * 0.8);
    background: rgb(240, 242, 246);
  }
  .box4 .title {
    width: 240px;
    height: 50px;
    font-size: 36px;
    margin: 0 auto calc(55px * 0.8);
    font-weight: 400;
    color: #000000;
    padding: calc(138px * 0.8) 0 calc(64px * 0.8) 0;
    position: relative;
  }
  .box4 .title img {
    width: calc(503px * 0.8);
    height: calc(75px * 0.8);
    position: absolute;
    bottom: calc(20px * 0.8);
    left: calc((50% - 251.5px) * 0.7);
  }
  .box4 .cont {
    width: calc(1200px * 0.8);
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
  }
  .box4 .cont .left_list,
  .box4 .cont .right_list {
    width: calc(250px * 0.8);
    height: calc(135px * 0.8);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    transition: all 0.5s linear;
    background-color: hsla(0, 0%, 0%, 0);
  }
  .box4 .cont .left_list img,
  .box4 .cont .right_list img {
    width: calc(66px * 0.8);
    height: calc(66px * 0.8);
    margin-bottom: calc(10px * 0.8);
  }

  .box4 .cont .left_list:hover {
    // background: url(../assets/img01/b4-left.png);
    background-size: cover;
    background-color: #fff;
  }
  .box4 .cont .right_list:hover {
    background-color: #fff;
    // background: url(../assets/img01/b4-right.png);
    background-size: cover;
  }
  .box4 .cont .left_list:hover::after {
    content: "";
    position: absolute;
    width: calc(4px * 0.8);
    height: calc(136px * 0.8);
    background: linear-gradient(288deg, #64baff 0%, #3484ff 100%);
    left: 0;
  }
  .box4 .cont .right_list:hover::after {
    content: "";
    position: absolute;
    width: calc(4px * 0.8);
    height: calc(136px * 0.8);
    background: linear-gradient(288deg, #64baff 0%, #3484ff 100%);
    right: 0;
  }
  .box4 .cont .activeL {
    // background: url(../assets/img01/b4-left.png);
    background-color: #fff;
    background-size: cover;
    position: relative;
  }
  .box4 .cont .activeL::after {
    content: "";
    position: absolute;
    width: calc(4px * 0.8);
    height: calc(136px * 0.8);
    background: linear-gradient(288deg, #64baff 0%, #3484ff 100%);
    left: 0;
    top: 0;
  }
  .box4 .cont .activeR {
    // background: url(../assets/img01/b4-right.png);
    background-color: #fff;
    background-size: cover;
    position: relative;
  }
  .box4 .cont .activeR::after {
    content: "";
    position: absolute;
    width: calc(4px * 0.8);
    height: calc(136px * 0.8);
    background: linear-gradient(288deg, #64baff 0%, #3484ff 100%);
    right: 0;
    top: 0;
  }

  .box4 .cont .left_list .bar,
  .box4 .cont .right_list .bar {
    font-size: 14px;
    font-weight: 400;
    color: #333333;
  }
  .box4 .middle {
    width: calc(699px * 0.8);
    height: calc(675px * 0.8);
    box-shadow: 10px 10px 24px 0px rgba(255, 255, 255, 0.6);
  }
  .box4 .middle .txt {
    font-size: 24px;
    color: #333333;
    margin: calc(40px * 0.8) calc(60px * 0.8);
    font-weight: 600;
  }
  .box4 .middle .txt_list div {
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    margin-bottom: calc(20px * 0.8);
    margin-left: calc(60px * 0.8);
    cursor: pointer;
  }
}

.box2 {
  // background-image: url("../assets/img01/nbg.png");
  // background-size: cover;
  // background-position: center;
  // background-repeat: no-repeat;
  background-color: #eceff1;
  padding-bottom: 60px;
}
.box2 .title span {
  position: relative;
  z-index: 1;
}

.box2 .lefr_z {
  margin-left: 0;
}
.box2 .cont .right {
  gap: 18px;
}
.box2 .lefr_r {
  margin-right: 0;
  padding-right: 0;
}

.box2 .lefr_z .txt {
  position: relative;
}
.box2 .lefr_z .txt::after {
  position: absolute;
  content: "";
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: linear-gradient(340deg, #2becfe 0%, #8d3efc 100%);
  opacity: 0;
  z-index: 0;
}
.box2 .lefr_z:hover .txt::after {
  opacity: 1;
}
.box2 .lefr_z:hover .txt_two,
.box2 .lefr_z:hover .txt_one {
  color: #fff;
}
@media (min-width: 768px) {
  .box2 .sam_txt {
    padding: 5.5px 15px;
  }
}
@media (min-width: 1000px) {
  .box2 .sam_txt {
    padding: 7.5px 15px;
  }
}
@media (min-width: 1100px) {
  .box2 .sam_txt {
    padding: 9.5px 15px;
  }
}
@media (min-width: 1200px) {
  .box2 .sam_txt {
    padding: 10.4px 15px;
  }
}
@media (min-width: 1400px) {
  .box2 .sam_txt {
    padding: 9.5px 23px;
  }
}
@media (min-width: 1500px) {
  .box2 .sam_txt {
    padding: 9px 23px;
  }
}
@media (min-width: 1680px) {
  .box2 .sam_txt {
    padding: 16px 23px;
  }
}

@media (min-width: 1280px) {
  .box2 .cont .right {
    width: 63%;
  }
  .box2 .h_txt {
    font-size: 14px;
  }
  .box2 .h_txt2 {
    font-size: 12px;
  }
  .box2 .cont a {
    font-size: 14px;
    margin-top: 0;
    // transform: translateY(-18px);
  }
  .box2 .lefr_z .txt {
    height: 82px;
  }
  .box2 .lefr_z .txt_one {
    font-size: 14px;
    height: 40px;
    margin-bottom: 2px;
  }

  .box2 .lefr_z .image {
    min-height: auto;
  }

  .box2 .lefr_z .txt_two {
    font-size: 12px;
  }
  .box2 .cont .right {
    height: auto;
  }
  .mis {
    top: 100px;
  }
  .box2 .sam_txt {
    // padding: 6px 23px 6px;
    border-bottom: 1px solid rgba(102, 102, 102, 0.1);
  }
}
@media (min-width: 1280px) and (max-width: 1680px) {
  .box2 .cont {
    width: 1043px;
    padding: 0;
    margin: 0 auto;
  }
  .box2 .lefr_z .image {
    height: 320px;
  }
}
@media (max-width: 1280px) {
  .box2 .cont a {
    // transform: translateY(-18px);
  }
}

@media (min-width: 1024px) {
  .box2 {
    padding-bottom: 60px;
  }
}
.box4 .content .s_li:hover .t2 {
  color: #4a47ff;
}
@media (max-width: 768px) {
  .box2 .cont {
    width: 60%;
    // padding: 0 17%;
  }
}
</style>
